import { RouteContext } from '../../contexts/RoutesContext';
import { useContext, useEffect } from 'react';

export function NotFound() {
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Not found", route: null }])
    }, []);

    return (<>
        <h1>Page not found</h1>
    </>)
}
